import { ReactChild } from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { Text, ToastSubtitle, ToastTitle, ToastWrapper } from './toast.styled';
import { alertHollow, errorIcon, successIcon } from '../../assets/icons';

interface CustomToastOptions {
  title: ReactChild;
  titleClick?: () => void;
  subtitle?: ReactChild;
  subtitleClick?: () => void;
  icon?: string;
  options?: ToastOptions;
  isLoading?: boolean;
  closeAll?: boolean;
}

export const showCustomToast = ({
  title,
  titleClick,
  subtitle,
  subtitleClick,
  icon,
  options,
  isLoading = false,
  closeAll = false,
}: CustomToastOptions) => {
  if (closeAll) {
    toast.dismiss();
  }
  const defaultOptions: ToastOptions = {
    type: 'default',
    autoClose: 5000,
    progressStyle: {
      background:
        'linear-gradient(270deg, #2D67D8 0%, #1769E4 0.01%, #FFFFFF 100%)',
    },
    isLoading,
    ...options, // Перезаписываем дефолтные настройки, если они есть в параметрах
  };

  const content: React.ReactNode = (
    <ToastWrapper>
      <ToastTitle onClick={titleClick && titleClick}>
        {icon && <img src={icon} alt="icon" />}
        <Text>{title}</Text>
      </ToastTitle>
      <ToastSubtitle onClick={subtitleClick && subtitleClick}>
        {subtitle}
      </ToastSubtitle>
    </ToastWrapper>
  );

  toast(content, defaultOptions);
};

export const successfulToast = (title?: string) => {
  showCustomToast({
    title: title || 'Успешно',
    icon: successIcon,
  });
};

export const errorToast = (title?: string) => {
  showCustomToast({
    title: title || 'Произошла ошибка',
    icon: errorIcon,
  });
};

export const infoToast = (title: string) => {
  showCustomToast({
    title,
    icon: alertHollow,
  });
};
